import { Location } from 'history';

// Organizations Paths
export const LoginPath = '/login';
export const LogoutPath = '/logout';
export const DashboardPath = '/dashboard';
export const HomePath = '/';

// Main Navigation Paths
export const OrganizationsPath = '/organizations';
export const LocationsPath = '/locations';
export const LocationDetailPath = '/locations/:id';
export const ReportsPath = '/reports';
export const SettingsPath = '/settings';
export const EmailMarketingPath = '/email-marketing';
export const EmailCampaignDetailPath = '/email-marketing/campaigns/:id';

// Organizations Management Paths (for future implementation)
export const OrganizationDetailPath = '/organizations/:id';
export const MarketplacesPath = '/marketplaces';
export const MarketplaceDetailPath = '/marketplaces/:id';
export const ServicesPath = '/services';
export const UsersPath = '/users';
export const AnalyticsPath = '/analytics';

// Utility functions
export const isPublic = (pathname: string): boolean => {
    const publicPaths = [LoginPath, LogoutPath];

    return publicPaths.some(path => {
        // Convert path pattern to regex for exact matching
        const regexPath = path.replace(/:[^/]+/g, '[^/]+');
        const regex = new RegExp(`^${regexPath}$`);
        return regex.test(pathname);
    });
};

export const requiresCleanUp = (pathname: string): boolean => {
    // Paths that require state cleanup when navigating to them
    // Note: LoginPath is NOT included here because LoginComponent handles its own cleanup on mount
    // Including it here would clear error messages after failed login attempts
    const cleanupPaths = [LogoutPath];

    return cleanupPaths.includes(pathname);
};

export const isProtected = (pathname: string): boolean => {
    return !isPublic(pathname);
};

// Helper function to build paths with parameters
export const buildPath = (path: string, params: Record<string, string | number>): string => {
    let builtPath = path;

    Object.entries(params).forEach(([key, value]) => {
        builtPath = builtPath.replace(`:${key}`, String(value));
    });

    return builtPath;
};

// Navigation helpers
export const getDefaultPath = (isAuthenticated: boolean): string => {
    return isAuthenticated ? DashboardPath : LoginPath;
};

export const getRedirectPath = (location: Location, isAuthenticated: boolean): string => {
    const { pathname } = location;

    if (isAuthenticated && isPublic(pathname)) {
        return DashboardPath;
    }

    if (!isAuthenticated && isProtected(pathname)) {
        return LoginPath;
    }

    return pathname;
};
